import React from 'react';
import Img from "../../images/services/tc/technology.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Reimagining The Strategic & Technology Landscape</h2>
                        <p>TekRevol counts on its experience in the technology industry to deliver unrivaled strategic and technology consultation services. From studying the market to devising customized strategies, we keep technology at the forefront of any technology solution and ensure all our clients achieve their objectives.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;